if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      this.performRecommendations();
    }

    /**
     * Oneri zinciri:
     *  1) data-url          -> intent=complementary (Search & Discovery ile ELLE tanimli)
     *  2) data-url-fallback -> intent=related       (Shopify otomatik onerisi)
     *  3) [data-xsell-fallback] -> tema tarafinda hesaplanan farkli-tema onerisi
     *
     * Tamamlayici urun tanimlanmadiginda 1. adim BOS doner; eskiden zincir
     * burada bitiyor ve bolum hic gorunmuyordu.
     */
    performRecommendations() {
      const recommendations = this.querySelector('[data-recommendations]');
      if (!recommendations) return;

      const urls = [this.dataset.url];
      if (this.dataset.urlFallback) urls.push(this.dataset.urlFallback);

      this.fetchStep(urls, 0, recommendations);
    }

    fetchStep(urls, index, recommendations) {
      if (index >= urls.length) {
        this.revealStaticFallback();
        return;
      }

      fetch(urls[index])
        .then(response => response.text())
        .then(text => {
          const recommendationsHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-recommendations]')?.innerHTML;

          // Bos donduyse (bosluk da bos sayilir) bir sonraki adimi dene.
          if (!recommendationsHTML || recommendationsHTML.trim() === '') {
            this.fetchStep(urls, index + 1, recommendations);
            return;
          }

          this.classList.remove('hidden');
          var cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
          if (cartDrawerItemsFull) {
            cartDrawerItemsFull.classList.remove('cart-drawer-items__full');
          }
          recommendations.innerHTML = recommendationsHTML;
          this.initSlider();

          // initiate quick cart after fetch
          // to activate trigger button events
          setTimeout(() => {
            if (document.querySelector("quick-cart-drawer")) {
              document.querySelector("quick-cart-drawer").init();
            } else {
              // if quick-cart-drawer does not exists, remove trigger buttons
              this.querySelectorAll(".quick-cart-drawer__trigger").forEach(el => {
                el?.remove();
              })
            }
          }, 500);
        })
        .catch(() => {
          this.fetchStep(urls, index + 1, recommendations);
        });
    }

    /** Her iki uc da bos donduyse tema tarafi oneriyi ac. */
    revealStaticFallback() {
      const scope = this.closest('[data-xsell-scope]') || this.parentElement;
      const fallback = scope?.querySelector('[data-xsell-fallback]');
      if (fallback) fallback.removeAttribute('hidden');
    }

    initSlider() {
      this.slider = new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 16,
      });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
